// extracted by mini-css-extract-plugin
export default {"button":"CookieConfirmButton_button__ByXk3","disabled":"CookieConfirmButton_disabled__R4IVV"};